// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"Board_boardContainer__1IfAk","textWrapper":"Board_textWrapper__1QQbY","text":"Board_text__1KF5V","rightIcons":"Board_rightIcons__31Kzt"};